module.exports = __webpack_public_path__ + "aea0e482ec2c4056f2697667b3533d1e.svg";